import { ITableField } from '@/shared/Tables/Table'
import {
  ILKDSConnectionRequest,
  ILPConnectionRequest,
  TConnectionRequestProtocol,
} from '@/pages/Equipment/equipment.types.ts'
import timeUtils from '@/utils/time.utils.ts'
import ConnectionRequestStatus from '@/pages/Equipment/components/Tables/ConnectionRequestsTable/ConnectionRequestStatus'

const lpConnectionRequestsTableFields: ITableField<
  ILPConnectionRequest,
  keyof ILPConnectionRequest | 'connection-status'
>[] = [
  {
    key: 'createdAt',
    clientSideOrdering: true,
    width: '300px',
    header: 'Дата попытки подключения',
    getter: (it) => timeUtils.formatDate(new Date(it.createdAt), 'dd MMM yyyy HH:mm'),
    sortGetter: (it) => it.createdAt,
  },
  {
    key: 'controllerId',
    clientSideOrdering: true,
    width: '300px',
    header: 'ID Контроллера',
    getter: (it) => it.controllerId,
    sortGetter: (it) => it.controllerId,
  },
  {
    key: 'connection-status',
    getter: (it) => <ConnectionRequestStatus protocol="lp-lift" request={it} />,
    clientSideOrdering: true,
    sortGetter: () => 1,
    header: 'Статус подключения',
    width: '300px',
  },
]

const lkdsConnectionRequestsTableFields: ITableField<
  ILKDSConnectionRequest,
  keyof ILKDSConnectionRequest | 'connection-status'
>[] = [
  {
    key: 'createdAt',
    clientSideOrdering: true,
    width: '300px',
    header: 'Дата попытки подключения',
    getter: (it) => timeUtils.formatDate(new Date(it.createdAt), 'dd MMM yyyy HH:mm'),
    sortGetter: (it) => it.createdAt,
  },
  {
    key: 'clientId',
    clientSideOrdering: true,
    width: '300px',
    header: 'ID клиента',
    getter: (it) => it.clientId,
    sortGetter: (it) => it.clientId,
  },
  {
    key: 'id',
    clientSideOrdering: true,
    width: '300px',
    header: 'ID запроса',
    getter: (it) => it.id,
    sortGetter: (it) => it.id,
  },
  {
    key: 'connection-status',
    getter: (it) => <ConnectionRequestStatus protocol="lkds" request={it} />,
    clientSideOrdering: true,
    sortGetter: () => 1,
    header: 'Статус подключения',
    width: '300px',
  },
]

function getConnectionRequestsTableFields(
  protocol: 'lkds'
): ITableField<ILKDSConnectionRequest, keyof ILKDSConnectionRequest | 'connection-status'>[]
function getConnectionRequestsTableFields(
  protocol: 'lp-lift'
): ITableField<ILPConnectionRequest, keyof ILPConnectionRequest | 'connection-status'>[]
function getConnectionRequestsTableFields(protocol: TConnectionRequestProtocol) {
  return protocol === 'lkds' ? lkdsConnectionRequestsTableFields : lpConnectionRequestsTableFields
}

export default getConnectionRequestsTableFields
